import React, { useContext, useEffect, useMemo, useState } from "react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import themeContext from "../../../../../context/theme/ThemeContext";

const AddTabVersion = (props) => {
    const {showVersionModalForReport,setShowVersionModalForReport} = useContext(studylistContext);
    const {getThemeColor,themeName} = useContext(themeContext);
    
    return (<>
    <div className="table-report">
        <ul id="horizontal-list" style={{minWidth:'unset'}} >
          {props?.data?.map((report, index) => {
            return (
              <li
                onClick={() => {
                    props.setActiveTabIndex(index);
                    props.setStudyReportPdfSelected(false);
                }}
                id={report.reportTemplateId}
                key={index}
                className={
                    index == props.activeTabIndex && !props.studyReportPdfSelected ? `${themeName}-active-li li-tab` : " li-tab"
                  }
                style={{background:  getThemeColor('report-not-active-tab'),color: getThemeColor("primary-color")}}
              >
                <span>{report.reportTemplateTitle}</span>
              </li>
            );
          })}

          {props.studyReportPdfDto && (
            <li
                onClick={() => {
                    props.setStudyReportPdfSelected(true);
                }}
                // id={report.reportTemplateId}
                key={"pdf-tab"}
                className={
                    props.studyReportPdfSelected ? `${themeName}-active-li li-tab` : " li-tab"
                  }
                style={{background:  getThemeColor('report-not-active-tab'),color: getThemeColor("primary-color")}}
              >
                <span>{`${props.studyReportPdfDto?.aiPacsNodeName || "PDF"} REPORT`}</span>
              </li>
          )}
        </ul>
      </div>
    </>)
};

export default AddTabVersion;